import { useOTSTranslation } from 'i18n/useOTSTranslation';
import FocusTrap from 'focus-trap-react';
import { useCallback, useState } from 'react';
import { Spinner } from 'components/Spinner';
import theme from 'theme';
import { getTypeformId } from 'util/getPortalConfig';
import styles from './styles.module.scss';

export const PopupFeedback = ({
  togglePopup,
  resort,
  id,
}: {
  togglePopup: () => void,
  resort: string,
  id: string,
}) => {
  const { t } = useOTSTranslation('common');
  const [isLoading, toggleIsLoading] = useState<boolean>(false);
  const path = 'https://form.typeform.com/to/';

  const setIsLoad = useCallback(() => {
    toggleIsLoading(true);
  }, []);

  const url = `${path}${getTypeformId()}?typeform-medium=embed-snippet#resort=${encodeURIComponent(resort)}&id=${encodeURIComponent(id)}`;

  return (
    <FocusTrap>
      <div className={styles.popupFeedback}>
        <div
          role="presentation"
          aria-hidden="true"
          tabIndex={-1}
          className={styles.background}
          onClick={togglePopup}
        />
        <div className={styles.popupBox}>
          {!isLoading && <Spinner color={theme.white} />}
          <iframe
            title={t('resort.skiReport.provideFeedback')}
            src={url}
            onLoad={setIsLoad}
            className={!isLoading ? 'hidden' : ''}
          />
          <button
            type="button"
            aria-label="close form feedback"
            className={styles.close}
            onClick={togglePopup}
          />
        </div>
      </div>
    </FocusTrap>
  );
};
